import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	registerCoins: Yup.number().min(0).required().label('Register Coins'),
	betPoints: Yup.number().min(0).required().label('Bet Points'),
	adRewardCoins: Yup.number().min(0).required().label('Ad Reward Coins'),
	maintenance: Yup.boolean().label('Maintenance'),
	maintenanceMessage: Yup.string().nullable().label('Maintenance Message'),
	showPopup: Yup.boolean().label('Show Popup'),
	popupTitle: Yup.string().nullable().label('Popup Title'),
	popupMessage: Yup.string().nullable().label('Popup Message'),
	popupType: Yup.string().nullable().label('Popup Type'),
	popupTargetId: Yup.number().nullable().label('Popup Target Id'),
	popupButtonText: Yup.string().nullable().label('Popup Button Text'),
	minimumVersionCode: Yup.string().nullable().label('Minimum Version Code'),
	minimumBuildNumber: Yup.string().nullable().label('Minimum Build Number'),
	minimumVersionName: Yup.string().nullable().label('Minimum Version Name'),
	storeUrlAndroid: Yup.string().nullable().label('Store Url Android'),
	storeUrlIos: Yup.string().nullable().label('Store Url Ios'),
	subscriptionBannerTitle: Yup.string().nullable().label('Subscription Banner Title'),
	subscriptionBannerText: Yup.string().nullable().label('Subscription Banner Text'),
});

const Inputs = [
	{
		name: 'registerCoins',
		label: 'Register Coins',
		type: 'text',
		value: 'single',
		valueAttr: 'registerCoins',
		required: true,
	},
	{
		name: 'betPoints',
		label: 'Bet Points',
		type: 'text',
		value: 'single',
		valueAttr: 'betPoints',
		required: true,
	},
	{
		name: 'adRewardCoins',
		label: 'Ad Reward Coins',
		type: 'text',
		value: 'single',
		valueAttr: 'adRewardCoins',
		required: true,
	},
	{
		name: 'maintenance',
		label: 'Maintenance',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'maintenance',
		required: false,
	},
	{
		name: 'maintenanceMessage',
		label: 'Maintenance Message',
		type: 'textarea',
		value: 'single',
		valueAttr: 'maintenanceMessage',
		required: false,
	},
	{
		name: 'popupSectionHeader',
		label: 'Popup',
		type: 'display',
		display: () =>
			'<div class="separator separator-dashed my-4"></div><h3 class="fs-4 fw-bold mb-2">Popup Settings</h3>',
	},
	{
		name: 'showPopup',
		label: 'Show Popup',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'showPopup',
		required: false,
	},
	{
		name: 'popupTitle',
		label: 'Popup Title',
		type: 'text',
		value: 'single',
		valueAttr: 'popupTitle',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.showPopup === true,
	},
	{
		name: 'popupMessage',
		label: 'Popup Message',
		type: 'textarea',
		value: 'single',
		valueAttr: 'popupMessage',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.showPopup === true,
	},
	{
		name: 'popupType',
		label: 'Popup Type',
		type: 'selectCustom',
		value: 'single',
		valueAttr: 'popupType',
		customOptions: () => [{ id: 'Tournament', name: 'Tournament' }],
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.showPopup === true,
	},
	{
		name: 'popupTargetId',
		label: 'Popup Target Id',
		type: 'text',
		value: 'single',
		valueAttr: 'popupTargetId',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.showPopup === true,
	},
	{
		name: 'popupButtonText',
		label: 'Popup Button Text',
		type: 'text',
		value: 'single',
		valueAttr: 'popupButtonText',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.showPopup === true,
	},
	{
		name: 'popupSectionFooter',
		label: '',
		type: 'display',
		display: () => '<div class="separator separator-dashed my-4"></div>',
	},
	{
		name: 'minimumVersionCode',
		label: 'Minimum Version Code (Androind)',
		type: 'text',
		value: 'single',
		valueAttr: 'minimumVersionCode',
		required: false,
	},
	{
		name: 'minimumBuildNumber',
		label: 'Minimum Build Number (iOS)',
		type: 'text',
		value: 'single',
		valueAttr: 'minimumBuildNumber',
		required: false,
	},
	{
		name: 'minimumVersionName',
		label: 'Minimum Version Name',
		type: 'text',
		value: 'single',
		valueAttr: 'minimumVersionName',
		required: false,
	},
	{
		name: 'storeUrlAndroid',
		label: 'Store Url Android',
		type: 'text',
		value: 'single',
		valueAttr: 'storeUrlAndroid',
		required: false,
	},
	{
		name: 'storeUrlIos',
		label: 'Store Url Ios',
		type: 'text',
		value: 'single',
		valueAttr: 'storeUrlIos',
		required: false,
	},
	{
		name: 'subscriptionBannerTitle',
		label: 'Subscription Banner Title',
		type: 'text',
		value: 'single',
		valueAttr: 'subscriptionBannerTitle',
		required: false,
	},
	{
		name: 'subscriptionBannerText',
		label: 'Subscription Banner Text',
		type: 'textarea',
		value: 'single',
		valueAttr: 'subscriptionBannerText',
		required: false,
	},
];

export { Inputs, validationSchema };
